import React from 'react';
import Modal from '@/src/component/modal/Modal';

import FormInputText from './_form/FormInputText';
import FormInputTextNum from './_form/FormInputTextNum';
import FormInputTextId from './_form/FormInputTextId';
import Loading from '@/src/component/_form/Loading';
import Submit from './Submit';
import SubmitSaved from './SubmitSaved';

import _TrialSchema from './_TrialSchema';

export default class TrialDetail extends React.Component {
  constructor (props) {
    super(props);
		this.wrapper= React.createRef();
    this.state= {
			save: false,
			data: _TrialSchema( props )
    }
  }

  setData= (propName, e)=> {
		this.setState( state=> ({
			data: {
				...state.data,
				[propName]: {
					...state.data[propName],
					value: e.target.value
				}
			}
		}) )

	}

	setDataVal= (propName, val, e)=> {
		this.setState( state=> ({
			data: {
				...state.data,
				[propName]: {
					...state.data[propName],
					value: val
				}
			}
		}) )

	}

	setDataObj= (propName, val, e)=> {
		this.setState( state=> ({
			data: {
				...state.data,
				[propName]: {
					...state.data[propName],
					...val
				}
			}
		}) )

	}

	setRef = ( key, ref )=> {
		this.setState( state=> ({
			data: {
				...state.data,
				[key]: {
					...state.data[key],
					elem: ref
				}
			}
		}) );
	}
  
  handleSave= ( val )=> {
		this.setState({ save: val });
	}
  
  render () {

    return (
      <Modal offModal={this.props.offModal.bind(null, 'modalDetail')}>
        
        <div ref={this.wrapper} className="modal-template bg-clr-wh">
          <div className="modal-template-content pd-60 m-pd-20 ">

            <div className="bd-gr2 pd-40 w100 mx800 mg-ct m-pd-s20">

              {
							this.state.save === 'loading' &&
							<Loading/>
							}

							{
							this.state.save !== false &&
							<SubmitSaved 
								IndexClass={this.props.IndexClass}
								offModal={this.props.offModal.bind(null, 'modalDetail')}
								msg={this.state.save}
							/>
							}


              {
              this.state.save === false &&
              <div className="">

                <h2 className='block-box ft-f1 ft0 ft-b m-ft0'>
                  무료 체험판 신청하기
                </h2>


								<div className="bd-bk pd-20 mg-h20">
									{/* <h2 className="ft3 ft-b ft-gr2">구매자정보</h2> */}
									<p className="mg-t5 txt-right">
										<i className="ft-mi v-mid ft3 ft-c5 m-ft4">info </i>
										<span className="v-mid m-ft5">
											필수항목을 모두 입력해야 신청이 가능합니다.
										</span>
									</p>

									<div className="mg-t20">
										<FormInputText
											onCreateRef={this.setRef}
											setData={this.setData}
											data={this.state.data['trial_users_name']}
                      fix={true}
										/>
										<FormInputText
											onCreateRef={this.setRef}
											setData={this.setData}
											data={this.state.data['trial_users_email']}
                      fix={true}
										/>
										<FormInputText
											onCreateRef={this.setRef}
											setData={this.setData}
											data={this.state.data['trial_biz_name']}
										/>
										<FormInputTextNum
											onCreateRef={this.setRef}
											setData={this.setDataVal}
											data={this.state.data['trial_biz_phone']}
										/>
										{/* <FormInputText
											onCreateRef={this.setRef}
											setData={this.setData}
											data={this.state.data['trial_ios']}
											placeholder="번들ID를 입력해주세요"
										/>
										<FormInputText
											onCreateRef={this.setRef}
											setData={this.setData}
											data={this.state.data['trial_android']}
											placeholder="프로젝트명을 입력해주세요"
										/> */}



										<div className="">
											<div className="bd-gr pd-s10 pd-b10">
												<FormInputTextId
													onCreateRef={this.setRef}
													setData={this.setDataObj}
													data={this.state.data['trial_ios']}
													placeholder="번들ID를 입력해주세요"
												/>
												<p className="ft5 lh-11 txt-right">
												번들 ID는 시스템 전체에서 단일 앱을 고유하게 식별합니다.<br/>
												번들 ID 문자열에는 영숫자(A–Z, a–z 및 0–9), 하이픈(-) 및 마침표(.)만 포함되어야 합니다.<br/>
												일반적으로 번들 ID 문자열에 역방향 DNS 형식을 사용합니다. 번들 ID는 대소문자를 구분합니다.
												</p>
											</div>
											<div className="bd-gr pd-s10 pd-b10 mg-t10">
												<FormInputTextId
													onCreateRef={this.setRef}
													setData={this.setDataObj}
													data={this.state.data['trial_android']}
													placeholder="프로젝트명을 입력해주세요"
												/>
												<p className="ft5 lh-11 txt-right">
												최소한 두 개의 세그먼트(하나 이상의 점)가 있어야 합니다.<br/>
												각 세그먼트는 문자로 시작해야 합니다.<br/>
												모든 문자는 영숫자 또는 밑줄[a-zA-Z0-9_]이어야 합니다.
												</p>
											</div>
										</div>
										
										
									</div>
								</div>

                <div className="pd-t10">
                  <p>
                    <i className="ft-mi v-mid ft3 ft-c5">info </i>
                    <span className="ft4 ft-b v-mid m-ft3">
                      주의사항
										</span>
                  </p>

                  <ul className="list-01 mg-t10 m-ft4">
                    <li className="">상업적 이용 금지</li>
                    <li className="">FIDO 기본 기능(등록/인증/해지)만 제공</li>
                    <li className="">체험판 이용을 위한 서버모듈은 당사 테스트서버를 제공함</li>
                    <li className="">신청순서에 따라 순차적으로 앱용 라이선스키 발송함</li>
                    <li className="">메일 저장공간 30Mb이상 필요</li>
                    {/* <li className="">
                      <span className="">
                        각 Client 모듈은 다운로드(
                          <a href="https://developer.ssenstone.com/download" className="txt-wrap ft-c5">
                            https://developer.ssenstone.com/download
                          </a>
                        ) 이용
                      </span>
                    </li> */}
                  </ul>

                </div>


                <Submit
									wrapper={this.wrapper}
                  onSave={this.handleSave}
                  submitData={this.state.data}
                />
              </div>
              }
              
            </div>

          </div>
        </div>
      </Modal>
    )
  }
}